import { useUser } from "../../../hooks/User";
import { Auth } from "aws-amplify";
import styles from "./logout.module.scss";

export const LogoutBtn = () => {
    const {endUserSession} = useUser();
    return (
        <button 
            onClick={() => Auth.signOut().then(() => endUserSession())}
            className={styles.logoutBtn}
        >
            Cerrar Sesión
        </button>
    )
}